<template>
  <div>
    <div v-if="loading" class="flex justify-center items-center loading-dialog3">
      <p class="text-gray-600 font-bold animate-pulse" style="font-size: 30px">Downloading...</p>
    </div>
    <PageHeader title="ダウンロード">
      <template #page-header-content>
        <div class="pl-4 flex justify-between">
          <h1 class="text-lg font-bold text-white flex items-center">
            <Icon iconName="" class="w-7 h-7 mr-2" />
            <span class="mt-0">巡回清掃 ダウンロード</span>
          </h1>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-28 w-full bottom-4 -mt-2">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <!-- 報告書ダウンロード -->
          <div class="bg-white rounded-md border border-blue-300 ---overflow-auto w-800px mr-auto ml-auto mt-5 p-5">
            <div class="items-center mt-3">
              <div class="text-sm text-gray-700 font-bold">実施日</div>
              <div>
                <DateSelect
                  id="filterDate"
                  ref="dateSelect"
                  class="border border-gray-300 rounded"
                  :presetName="periodPresetName"
                  :period="period"
                  :none="true"
                  @change="periodChange"
                />
              </div>
            </div>

            <!-- 得意先OR物件名 選択ボタン -->
            <div class="flex mt-5">
              <PrimaryButton text="得意先で絞る" class="py-1 mr-3" :class="filterClient?'' : 'bg-gray-300'" @click="filterClient=true" :buttonContents="'要'" />
              <PrimaryButton text="物件名で絞る" class="py-1" :class="!filterClient?'' : 'bg-gray-300'" @click="filterClient=false" :buttonContents="'要'" />
            </div>

            <!-- 得意先OR物件名 絞り込み -->
            <div v-if="filterClient" class="mt-1 text-sm text-gray-700 font-bold">得意先</div>
            <div v-else class="mt-1 text-sm text-gray-700 font-bold">物件名</div>
            <div class="p-1 rounded-md border border-gray-300">
              <WmsSuggestInput
                v-if="filterClient"
                name="client"
                :embed="true"
                displayField="clientName"
                :dynamic="false"
                :incrementalSearch="false"
                :selectionItems="clientList"
                :disabled="disabledClient"
                class="embed"
                :class="disabledClient?'cursor-pointer' : ''"
                v-model="client.name"
                @selected="selectClient($event)"
                @change="changeClient()"
              />
              <WmsSuggestInput
                v-else
                name="site"
                :embed="true"
                displayField="siteName"
                :dynamic="false"
                :incrementalSearch="false"
                :selectionItems="siteList"
                :disabled="disabledClient"
                class="embed"
                :class="disabledClient?'cursor-pointer' : ''"
                v-model="siteName"
                @selected="selectSite($event)"
              />
            </div>

            <div class="mt-5 w-750">
              <PrimaryButton text="報告書 ダウンロード" size="normal px-2 py-2  " class="w-full" @click="download()" />
            </div>
          </div>

          <!-- Google共有ドライブにアップ -->
          <div class="mt-20 py-5 px-10 rounded bg-blue-50 w-fit mx-auto">
            <div class="flex justify-center">
              <div>  
                <div class="text-xs text-gray-700 mb-0.5 font-bold">完了日</div>
                <input
                  type="date"
                  class="py-1"
                  v-model="googleDate"
                  :max="max"
                >
              </div>
              <div class="mx-3 mt-auto">に完了した</div>
              
              <WmsSuggestInput
                name="client"
                caption="得意先（指定がある場合）"
                displayField="clientName"
                :dynamic="false"
                :incrementalSearch="false"
                :selectionItems="clientList"
                class=""
                v-model="client.name3"
                @selected="selectClient2($event)"
                @change="changeClient2()"
              />
              <div class="mx-3 mt-auto">の</div>
              
              <WmsSuggestInput
                name="site"
                caption="物件（指定がある場合）"
                displayField="siteName"
                :dynamic="false"
                :incrementalSearch="false"
                :selectionItems="siteList"
                class=""
                v-model="siteName"
              />
              <div class="mx-3 mt-auto">の報告書を</div>
            </div>

            <div class="text-center mt-5"><PrimaryButton text="Google共有ドライブへアップ" :disabled="!googleDate||!admin" :class="!admin?'bg-gray-400':''" @click="roundReportToGoogle" :buttonContents="'要'" /></div>
            
            <div class="text-center mt-5 text-sm">管理者権限のみGoogle共有ドライブへアップ可能</div>
            <div class="text-center mt-5 text-sm text-red-700">※毎晩自動でアップしています。エラー等でアップできなかった場合のみご利用ください。</div>
          </div>

          <div class="text-transparent">{{reload}}</div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import DateSelect from '@components/DateSelect.vue'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import { RLS_OLD_FORMAT } from '@libs/constants'
import * as moment from 'moment'
import PageModel from '../../main/pages/PageModel.vue'

const CL = { clientCode: '', name: '', name1: '', name2: '', name3: '' }

export default {
  extends: PageModel,
  components: {
    Icon,
    WmsSuggestInput,
    PrimaryButton,
    DateSelect,
    PageHeader
  },

  data() {
    return {
      loading: false,
      type: 2,
      typeName: '巡回清掃',
      // 得意先一覧
      clientList: [],
      // 物件一覧
      siteList: [
        { siteName: '' }
      ],
      // 得意先
      client: utils.clone(CL),
      // 物件
      siteName: '',
      // サイクル期限日
      periodPresetName: 'custom',
      period: {
        start: '',
        end: ''
      },
      // 得意先非活性
      disabledClient: false,
      // 得意先で絞り込みか否か
      filterClient: true,
      // 画面即時反映
      reload: 0,
      // Google共有ドライブへアップする完了日
      googleDate: moment().add(-1, 'days').format('YYYY-MM-DD'),
      // 昨日以前の日付のみ
      max: moment().add(-1, 'days').format('YYYY-MM-DD'),
      // 管理者権限あり
      admin: false
    }
  },

  computed: {
  },

  watch: {
    /**
     * サイクル期限
     */
    period: {
      handler: async function () {
        this.clientList = []
        this.client = utils.clone(CL)
        this.siteList = [{ siteName: '' }]
        this.siteName = ''
        // 開始日・終了日が設定されていない
        if (!this.period.start && !this.period.end) {
            await this.getClientList()
            await this.getSiteList()

        // 開始日、終了日どちらも設定されている
        } else if (this.period.start && this.period.end) {
          // 開始日と終了日が前後していない
          const start = Number(this.period.start.replace(/-/g, ''))
          const end = Number(this.period.end.replace(/-/g, ''))
          if (start <= end) {
            await this.getClientList()
            await this.getSiteList()
          }
        }
      },
      deep: true
    }
  },

  async created() {
    let auth = this.$store.getters.auth
    if (auth && auth.adminAuth) {
      this.admin = true
    }
  },

  methods: {

    /**
     * 得意先選択イベント
     * @param e 対象
     */
    selectClient(e) {
      this.client.clientCode = e.clientCode
      this.siteName = ''
    },

    /**
     * Google共有ドライブ得意先選択イベント
     * @param e 対象
     */
    selectClient2(e) {
      this.client.name1 = e.name1
      this.client.name2 = e.name2
      this.siteName = ''
    },

    /**
     * 得意先変更イベント
     */
    changeClient() {
      if (this.client.name == '') {
        this.client = utils.clone(CL)
      }
    },

    /**
     * Google共有ドライブ得意先変更イベント
     */
    changeClient2() {
      if (this.client.name3 == '') {
        this.client = utils.clone(CL)
      }
    },

    /**
     * 物件選択イベント
     */
    selectSite() {
      this.client = utils.clone(CL)
    },

    /**
     * サイクル期限 変更
     */
    periodChange(range, presetName) {
      this.period = range
      this.periodPresetName = presetName
    },

    /**
     * 得意先リストを取得
     */
    async getClientList() {
      const cR = await backend.searchData('patrolResult/getGroupingClientByTerm', { start: this.period.start, end: this.period.end, type: this.type })
      if (cR.data && cR.data.data.length) {
        this.clientList = cR.data.data
        this.disabledClient = false
      } else {
        this.clientList = []
        await dialogs.showInfoDialog('該当データなし', '選択した期限では清掃実施した物件がありません。')
        this.disabledClient = true
      }
    },

    /**
     * 物件リストを取得
     */
    async getSiteList() {
      const cR = await backend.searchData('patrolResult/getGroupingSiteByTerm', { start: this.period.start, end: this.period.end, type: this.type })
      if (cR.data && cR.data.data.length) {
        this.siteList = cR.data.data
      } else {
        this.siteList = [{ siteName: '' }]
      }
    },

    /**
     * 報告書ダウンロードイベント
     */
    async download() {
      let name = ''

      if (this.filterClient && (!this.client.clientCode || this.client.clientCode == '')) {
        await dialogs.showErrorDialog('得意先未選択', '得意先を選択してください。')
        return
      } else if (!this.filterClient && !this.siteName) {
        await dialogs.showErrorDialog('物件未選択', '物件を選択してください。')
        return
      }

      this.loading = true

      const param = { start: this.period.start, end: this.period.end, clientName: this.client.name, siteName: this.siteName, filterClient: this.filterClient, type: this.type, claim: false, routeName: 'RoundDownload', oldFormat: RLS_OLD_FORMAT }

      // ファイル名生成
      if (this.filterClient) {
        // 得意先名
        if (this.client.name) {
          name = this.client.name.replace('株式会社', '')
        }
      } else {
        // 物件名
        if (this.siteName) {
          name = this.siteName
        }
      }
      try {
        const res = await backend.postBlob('patrolDownload/downloadRoundClean', param)
        const uint8Array = res.data
        const blob = new Blob([uint8Array], { "Content-Type" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement("a");
        a.href = (window.URL || window.webkitURL).createObjectURL(blob)
        a.download = name + moment().format('YYYY-MM-DD') + '.xlsx'
        a.click();
        a.remove();
      } catch (e) {
        alert('写真が多すぎてタイムアウトになったか、該当のデータがありません。\r\n条件を変更してください。')
        console.log(e)
      }
      this.loading = false
    },

    /**
     * 巡回清掃報告書Google共有ドライブへアップロード
     */
    async roundReportToGoogle() {
      if (!this.admin) {
        alert('管理者のみ可能です。')
        return
      }
      await backend.postData('cron/reportToGoogle', { from: 'rp', date: this.googleDate, client: this.client, site: this.siteName, type: 2 })
      dialogs.showInfoDialog('結果はGoogle共有ドライブ内の「結果ログ」参照', 'アップには時間がかかります。時間をおいて、Google共有ドライブの対象フォルダを確認するか「結果ログ」をご確認ください。\r\nこの画面は閉じて大丈夫です。')
    }

  },
}
</script>
<style scoped>
.main {
  width: 100%;
}

.w-800px {
  width: 800px;
}

.w-750 {
  width: 750px;
}

#filterDate {
  width: 100% !important;
}

#filterDate >>> div {
  color: rgb(70, 70, 70) !important;
}

#filterDate >>> input[type=text] {
  background: white !important;
}
</style>